import { connect } from 'react-redux';
import { setCurrentTab } from 'store/siteCoordinator/siteCoordinator.actions';
import {
  viewPodCastStart,
  fetchPodCastEpisodeStart
} from 'store/podcast/podcast.actions';
import { setCurrentViewdPodPlaylist } from 'store/podcastPlaylist/podcastPlaylist.actions';

const mapStateToProps = (state) => ({
  playerPodCastState: state.playerPodCast,
  podcastPlaylistState: state.podcastPlaylist
});

const mapDispatchToProps = (dispatch) => ({
  onSetCurrentTab: (value) => dispatch(setCurrentTab(value)),
  onViewPodCastStart: (value) => dispatch(viewPodCastStart(value)),
  onFetchPodCastEpisode: (podcastId) =>
    dispatch(fetchPodCastEpisodeStart(podcastId)),
  onSetCurrentViewdPodPlaylist: (podcastId) =>
    dispatch(setCurrentViewdPodPlaylist(podcastId))
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
